/**
 * Интерфейс документа для просмотра (закон, приказ и т.п.)
 */
export interface Document {
  id: string;
  title: string;
  category: string;
  content: string;
}

/**
 * Асинхронная загрузка всех правовых документов через dynamic import.
 * Каждый .md-файл попадает в отдельный code-split чанк и не входит
 * в начальный бандл приложения, что критично для LCP.
 *
 * @returns Массив объектов Document с содержимым файлов
 */
export const loadDocumentsAsync = async (): Promise<Document[]> => {
  const [fedLaw, weapons, criminal, guard] = await Promise.all([
    // TODO: заменить на fetch('/documents/...md') если .md-файлы переедут в public/
    import('./documents/Federal_Law_No._77_FZ_of_14_April_1999_on_Departmental_Security.md?raw'),
    import('./documents/FEDERAL_LAW_ON_WEAPONS.md?raw'),
    import('./documents/Articles_of_the_Criminal_Code_of_the_Russian_Federation.md?raw'),
    import('./documents/The_order_of_the_Russian_Guard.md?raw'),
  ]);

  return [
    {
      id: 'doc1',
      title: 'Федеральный закон о ведомственной охране',
      category: 'Правовая подготовка',
      content: fedLaw.default
    },
    {
      id: 'doc2',
      title: 'Федеральный закон об оружии',
      category: 'Правовая подготовка',
      content: weapons.default
    },
    {
      id: 'doc3',
      title: 'Статьи Уголовного кодекса РФ',
      category: 'Правовая подготовка',
      content: criminal.default
    },
    {
      id: 'doc4',
      title: 'Приказ Росгвардии о периодических проверках',
      category: 'Правовая подготовка',
      content: guard.default
    }
  ];
};
